import { Jodit } from "jodit-react";
import i18n from "./i18n";
import DOMPurify from "dompurify";

// all options from https://xdsoft.net/jodit/docs/,
const joditOptions = () => {
  function removeCommentNodes(element: HTMLElement) {
    const nodes = element.childNodes;
    for (let i = 0; i < nodes.length; i++) {
      if (nodes[i].nodeType === 8) {
        nodes[i].remove();
      }
    }
  }

  function sanitizeHtml(html: any) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    doc.body.querySelectorAll("*").forEach((el) => {
      console.log("el", el.tagName);

      if (el.tagName === "O:P") {
        el.remove();
      } else {
        el.removeAttribute("class");
        el.removeAttribute("lang");
        el.removeAttribute("style");
      }
    });

    removeCommentNodes(doc.body);

    return doc.body.innerHTML;
  }

  function sanitizePlainTextWithLineBreaks(text: string) {
    // Replace newlines with <br /> to preserve line breaks
    const sanitized = DOMPurify.sanitize(text);
    return sanitized.replace(/\n/g, "<br />");
  }

  return {
    language: i18n.language,
    height: "300px",
    readonly: false,
    disablePlugins: ["resizer", "resizeHandler", "poweredByJodit", "preview", "aiAssistant", "mobile", "paste", "stat", "xpath", "addNewLine"],
    buttons: [
      "paragraph",
      "|",
      "bold",
      "italic",
      "underline",
      "strikethrough",
      "|",
      "ul",
      "ol",
      "align",
      "indent",
      "outdent",
      "|",
      "superscript",
      "link",
      "|",
      "source",
    ],
    placeholder: "",
    allowResizeY: true,
    toolbarAdaptive: true,
    events: {
      beforeInit: (jodit: any) => {
        jodit.events.on("paste", (e: DragEvent | ClipboardEvent) => {
          e.preventDefault();
          e.stopPropagation();

          const dataTransfer = Jodit.modules.Helpers.getDataTransfer(e);
          if (dataTransfer) {
            const pastedHTML = dataTransfer.getData(Jodit.constants.TEXT_HTML);
            if (pastedHTML) {
              const sanitizedContent = sanitizeHtml(pastedHTML);
              console.log(sanitizedContent);
              jodit.s.insertHTML(sanitizedContent);
            } else {
              const pastedText = dataTransfer.getData(Jodit.constants.TEXT_PLAIN);
              if (pastedText) {
                const sanitizedText = sanitizePlainTextWithLineBreaks(pastedText);
                jodit.s.insertHTML(sanitizedText);
              }
            }
          }
          return false;
        });
      },
    },
  };
};

export default joditOptions;
